import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['../styles.css', '../../node_modules/bootstrap/dist/css/bootstrap.css']
})
export class AppComponent {
  title = 'lukakrstik';
}
